import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useState } from "react";
import ArrowDown from "@/assets/ArrowDown.svg";

export const FAQ = () => {
  const [showAll, setShowAll] = useState(false);

  const allFaqs = [
    // {
    //   question: "What is KaratClub?",
    //   answer: "KaratClub is a first-of-its-kind investment club that rewards you for being a responsible investor, with real-world benefits. As you become a member, you unlock lifestyle perks such as premium discounts and zero-cost EMIs, all while your money stays invested and continues to earn returns."
    // },
    // {
    //   question: "How does KaratClub work?",
    //   answer: "When you join, Karat Club securely fetches the value of your existing mutual fund holdings and grants you access as a member, post a careful review process. It links the value of your existing mutual funds as collateral to unlock exclusive benefits, such as discounts and zero-cost EMIs. You retain full ownership of your investments, which remain invested and continue to earn returns unless the EMIs go unpaid."
    // },
    // {
    //   question: "How do I get in?",
    //   answer: "KaratClub is built to be an exclusive members-only experience. Once you give us basic information about yourself, our team will carefully review your application and get back at the earliest regarding your membership status. We encourage our members to explore the platform before signing up."
    // },

    // {
    //   question: "Do I need to invest in new mutual funds to join?",
    //   answer: "No. You can join with the mutual funds you already own. KaratClub recognises your existing portfolio and connects it to your membership, allowing you to start accessing rewards right away. We believe in rewarding people to be responsible investors – regardless of where they invest."
    // },
    // {
    //   question: "Will my mutual funds be sold or affected in any way?",
    //   answer: "Not at all. Your mutual funds remain in your name and continue to be invested as usual. Hence this doesn't impact your ownership or returns unless any EMIs are unpaid."
    // },
    // {
    //   question: "What kind of rewards can I expect?",
    //   answer: "Members enjoy a growing range of lifestyle perks — from premium brand discounts and zero-cost EMI options to exclusive experiences in travel, dining, and tech. The higher your membership tier, the greater the benefits you can unlock."
    // },
    // {
    //   question: "Is it safe to link my mutual funds?",
    //   answer: "Yes, completely. KaratClub partners only with trusted financial institutions and adheres to strict security and compliance standards. It also partners with AMFI-registered mutual fund distributors, to ensure your investments remain safe with SEBI-regulated fund houses, in your name and control."
    // },
    // {
    //   question: "How do you unlock these rewards without touching my money?",
    //   answer: "Simply join the waitlist on our website. Once we go live, you'll get early access to connect your portfolio, explore your personalised rewards, and begin your KaratClub experience."
    // },
    // {
    //   question: "How do I become a member?",
    //   answer: "Simply join the waitlist on our website. Once we go live, you'll get early access to connect your mutual funds, explore your personalised rewards, and begin your KaratClub experience."
    // },
    // {
    //   question: "Will new brands and rewards be added over time?",
    //   answer: "Yes. We're continuously adding lifestyle partners across travel, retail, tech, and luxury categories, ensuring your membership becomes more rewarding as you grow."
    // },
    {
      question: "How do I get in?",
      answer: `To qualify for KaratClub membership, you must:
- Hold an active mutual fund portfolio in India
- Meet the platform's basic eligibility and verification requirements

Membership is available by invitation or approval, and access is limited to ensure a premium experience for all members.`
    },
    {
      question: "How do I apply for KaratClub membership?",
      answer: `You can apply by:
- Joining via an invite link, or
- Submitting a request through the KaratClub platform

Our team will review your eligibility and guide you through a quick onboarding process.`
    },
    {
      question: "What benefits do members get on purchases?",
      answer: `As a KaratClub member, you gain access to:

- Exclusive member-only discounts
- Zero-cost EMI options on select purchases
- Priority access to limited-period offers and experiences

These benefits are not available outside the platform.`
    },
    {
      question: "Why is a mutual fund portfolio required for membership?",
      answer: `KaratClub is built for financially responsible, long-term investors. Your mutual fund portfolio enables access to a loan against mutual funds (LAMF) facility, which in turn unlocks exclusive rewards, offers, and flexible payment options across partner brands.`
    },
    {
      question: "Do I have to use the credit line to stay a member?",
      answer: `Yes. Availing the credit line is a core requirement of KaratClub membership, as all rewards, benefits, and partner offers are designed around responsible usage of this facility.

That said, you remain in control of when, how much, and where you use the credit line.`
    },
    {
      question: "What is the credit line offered through KaratClub?",
      answer: `The credit line is a loan against your mutual fund investments, provided by regulated lending partners.
It allows you to:

- Access liquidity without selling your investments
- Make lifestyle purchases while your mutual funds remain invested

The credit line amount depends on the value and composition of your mutual fund portfolio.`
    },
    {
      question: "Is KaratClub an investment platform?",
      answer: `No. KaratClub is not an investment advisory or distribution platform.
It is a lifestyle and rewards platform that leverages your existing mutual fund portfolio to unlock benefits through a regulated credit facility.`
    },
    {
      question: "What can I use the credit line for?",
      answer: `The credit line can be used exclusively to purchase products and services from KaratClub's partner brands, spanning categories such as:

- Lifestyle & consumer products
- Travel & experiences
- Premium services and curated offerings`
    },
    {
      question: "Are lending partners regulated?",
      answer: `Yes. The loan against mutual funds facility is offered by SEBI-registered AMCs and RBI-regulated lending partners, ensuring transparency, compliance, and security.`
    },
    {
      question: "Can I exit KaratClub anytime?",
      answer: `Yes. You may choose to exit the platform at any time, subject to:

- Repayment of any outstanding credit line dues
- Release of pledged mutual fund units post repayment

There are no lock-ins beyond standard loan terms.`
    },
    {
      question: "Do I need to invest on KaratClub's platform to be eligible?",
      answer: `No. You do not need to make any new investments or shift your existing investments to KaratClub to be eligible.

If you already hold an active mutual fund portfolio in India, you can apply for KaratClub membership by linking your existing investments during onboarding. These investments are used only to assess eligibility and enable the loan against mutual funds facility.

KaratClub does not require you to buy, sell, or transfer mutual funds on its platform.`
    }
  ];


  // Show only first 5 FAQs initially
  const visibleFaqs = showAll ? allFaqs : allFaqs.slice(0, 5);

  return (
    <section id="faq" className="" style={{ borderRadius: '23px' }}>
      <div className="flex flex-col lg:mb-10 md:flex-row md:items-start md:justify-between">
        <h2 className="text-xl md:text-6xl font-medium mb-4 md:mb-0 md:w-9/12">
          <span className="block md:hidden">Got Questions?</span>
          <span className="hidden md:block">Got Questions?</span>
          <div className="bg-[#DBAD71] w-[200px] h-[1px] rounded-[19px] opacity-100 md:h-[4px]"></div>
          <span className="font-regular text-sm  mt-2  text-[#FFFFFF99] block md:hidden">We’ve Got You Covered </span>
        </h2>
      </div>

      <div className="mx-auto">
        <Accordion type="single" collapsible className="space-y-4">
          {visibleFaqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-[#1D1D21] rounded-lg border-none"
            >
              <AccordionTrigger className="text-left hover:no-underline p-6 group [&_svg]:hidden flex items-center justify-between">
                <span className="font-regular text-[#F7F7F7] text-sm md:text-lg md:font-semibold pr-4">{faq.question}</span>
                <div className="flex items-center">
                  <span className="text-2xl text-gray-500 group-data-[state=open]:hidden leading-none">+</span>
                  <span className="text-2xl text-gray-500 hidden group-data-[state=open]:inline leading-none">-</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-[#FFFFFF99] md:font-regular px-6 pb-6 pt-2 text-base font-regular md:text-lg">
                {faq.answer.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < faq.answer.split('\n').length - 1 && <br />}
                  </span>
                ))}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* View All / Show Less Button */}
        <div className="flex justify-center mt-8">
          <button
            onClick={() => setShowAll(!showAll)}
            className="px-6 py-3  text-[#DBAD71] font-medium rounded-lg  transition-colors flex items-center"
          >
            <span className="mr-2.5">{showAll ? "Show Less" : "View More"}</span>
            <img
              src={ArrowDown}
              alt=""
              className={`transition-transform duration-300 ${showAll ? 'rotate-180' : ''}`}
              style={{ marginLeft: '5px' }}
            />
          </button>
        </div>
      </div>
    </section>
  );
};